import RootLayout from "components/layout/rootLayout";
import React from "react";

type Props = {};

export default function Support({}: Props) {
  return (
    <RootLayout>
      <div className="flex justify-center items-center  w-full h-full my-5 mx-2">
        <div className="bg-white rounded-xl p-7 px-12 mt-4 shadow-xl ">
          <div className="pt-5 text-right">
            <h1 className="mb-6 font-semibold text-right text-3xl underline underline-offset-8 text-sky-500">
              تماس با ما{" "}
            </h1>

            <div className="mt-6">
              <p className="text-gray-500">آدرس </p>
              <p className="text-sky-600 font-semibold">
                تهران، میدان کاج، خیابان سرو شرقی، خیابان مجد کوچه نسترن پلاک ۳۴
              </p>
            </div>
            <div className="mt-6">
              <p className="text-gray-500">شماره پشتیبانی</p>
              <p className="text-sky-600 font-semibold"> 021-۷۴۳۱۸۸۳۵ </p>
            </div>
            <div className="mt-6">
              <p className="text-gray-500">شماره فروش</p>
              <p className="text-sky-600 font-semibold"> 021-۷۴۳۱۸۰۵۰</p>
            </div>
            <div className="mt-6">
              <p className="text-gray-500">ایمیل فروش</p>
              <p className="text-sky-600 font-semibold">market@partdp.ir</p>
            </div>
          </div>
        </div>
      </div>
    </RootLayout>
  );
}
